import * as ReactJSXRuntime from "react/jsx-runtime";
import { h as hasOwn, E as Emotion$1, c as createEmotionProps } from "../../dist/emotion-element-5486c51c.browser.esm.js";
import "react";
import "../../../../hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js";
var Fragment = ReactJSXRuntime.Fragment;
function jsx(type, props, key) {
  if (!hasOwn.call(props, "css")) {
    return ReactJSXRuntime.jsx(type, props, key);
  }
  return ReactJSXRuntime.jsx(Emotion$1, createEmotionProps(type, props), key);
}
export {
  Fragment,
  jsx
};
